module.exports = __webpack_public_path__ + "img/Frame 43.5f4fc228.svg";